module.exports = __webpack_public_path__ + "static/media/SWAT-Icon-Orange.3419d7e3.png";